import React, { useState } from 'react';
import { bulkUpdateCourseEnrolments } from '../../services/courseEnrolmentService';
import {
  Form,
  Modal,
  Select,
  Row,
  Col,
  Button,
  Typography,
  Spin
} from 'antd';
import '../Common/Form.css';

const { Text } = Typography;

const CourseEnrolmentBulkEdit = (props) => {
  const { isVisible, setIsVisible, formData, selectedRowKeys } = props;
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState({
    error: false,
    message: ''
  });

  const onSubmit = async (value) => {
    const body = {
      op: 'replace',
      value: value.courseEnrolmentStatus,
      path: 'courseEnrolmentStatus',
      courseEnrolmentIds: selectedRowKeys
    };
    setLoading(true);
    await bulkUpdateCourseEnrolments(body)
      .then(() => {
        setIsVisible(false);
      })
      .catch((err) => {
        setStatus({
          error: true,
          message: `${err}`
        });
      });
    setLoading(false);
  };

  return (
    <Modal
      visible={isVisible}
      title={'Bulk Update selected Course Enrolments'}
      onCancel={() => setIsVisible(false)}
      footer="">
      <Form
        onFinish={onSubmit}
        labelCol={{ span: 7 }}
        wrapperCol={{ span: 21 }}>
        <Form.Item label="Course Offer Id*">
          <Text>{formData.courseOfferId}</Text>
        </Form.Item>
        <Form.Item label="Course Offer Code*">
          <Text>{formData.courseOfferCode}</Text>
        </Form.Item>
        <Form.Item label="Learners*">
          {formData.learners.length !== 0 ? (
            formData.learners.map((item) => {
              return (
                <Text>
                  {item.learner.firstName + ' ' + item.learner.lastName}
                  <br />
                </Text>
              );
            })
          ) : (
            <Text>None Selected</Text>
          )}
        </Form.Item>

        {status.error ? (
          <div style={{ margin: '10px', textAlign: 'center' }}>
            <Text type="danger">{status.message}</Text>
          </div>
        ) : (
          <></>
        )}

        <Form.Item label="Status" name="courseEnrolmentStatus">
          <Select>
            <Select.Option value="Pending">
              Pending - Paid Deposit Only
            </Select.Option>
            <Select.Option value="Current">
              Current - Fully Paid
            </Select.Option>
            <Select.Option value="Inactive">Inactive - ...</Select.Option>
            <Select.Option value="Completed">
              Completed - Completed course offer
            </Select.Option>
            <Select.Option value="Transferred">
              Transferred - Transferred to another course offer
            </Select.Option>
            <Select.Option value="Withdrawn">
              Withdrawn - Withdrawn
            </Select.Option>
            <Select.Option value="Cancelled">
              Cancelled - Enrolment cancelled
            </Select.Option>
          </Select>
        </Form.Item>
        <Row justify="end" gutter={12}>
          <Col>
            {loading ? (
              <Spin />
            ) : (
              <Button type="primary" htmlType="submit">
                Bulk Update
              </Button>
            )}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CourseEnrolmentBulkEdit;
